<template>
    <div class="hsl-plot">
        <div class="hsl-gradient"
             ref="gradient"
             :style="'background:'+getHueOutput()+' ;'" @mousedown="start" @mouseup="end">

            <div class="hsl-gradient-bg hsl-gradient-saturation"></div>
            <div class="hsl-gradient-bg hsl-gradient-lightness"></div>

            <div class="hsl-gradient-crosshair" :style="crosshairPositionCss">
                <div class="hsl-gradient-crosshair-inner"></div>
            </div>
        </div>
        <slider class="hue mt stagger-in-up" :max="360" :value="hue" @input="updateField($event, 'hue')"/>
    </div>
</template>

<script>
    import Slider                 from "./Slider";
    import HsvBase                from "./HsvBase";
    import {mousePositionElement} from "../../../../../Lib/helpers/mousePosition";
    import Color                  from "../../../../../Lib/Color";

    export default {
        name: "GradientPicker",
        extends: HsvBase,
        components: {Slider},

        data() {
            return {
                handler: null,
            }
        },

        computed: {

            crosshairPositionCss() {
                let value = Math.abs(this.displayValue - 100);

                let left = 'left: calc(' + this.saturation + '% - 5px);';
                let top  = 'top: calc(' + value + '% - 5px);';

                return left + top;
            },

            gradientElement() {
                return this.$refs.gradient;
            }

        },

        methods: {

            start(event) {
                this.pickColor(event);

                document.addEventListener('mousemove', this.pickColor);
                document.addEventListener('mouseup', () => document.removeEventListener('mousemove', this.pickColor))
            },

            end() {
                document.removeEventListener('mousemove', this.pickColor);
            },

            pickColor: _.throttle(function(event) {
                let element = this.gradientElement;

                let {x, y} = mousePositionElement(event, element);

                this.updateSaturation(element, x);
                this.updateValue(element, y)
            }, 50),


            updateSaturation(element, x) {
                let w = element.offsetWidth;

                let saturation = x / w * 100;

                this.updateField({target: {value: saturation}}, 'saturation');
            },

            updateValue(element, y) {
                let h = element.offsetHeight;

                let pos = y / h - 1;
                if(pos > 0) {
                    pos = 0;
                }

                let value = Math.abs(pos) * 100;

                this.updateField({target: {value: value}}, 'value');
            },

            getHueOutput() {
                return Color.fromHSL({hue: this.hue, saturation: 100, lightness: 50}).hex().value;
            },
        }
    }
</script>

<style lang="scss" scoped>

    $height: 9rem;

    .hsl-gradient {
        width: 100%;
        height: $height;
        position: relative;
        border-radius: 5px 5px 7px 5px;
    }

    .hsl-gradient-bg {
        position: absolute;
        width: 100%;
        height: $height;
        border-radius: 5px;
    }

    .hsl-gradient-saturation {
        background: linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 100%);
        border-radius: 5px 5px 5px 7px;
    }

    .hsl-gradient-lightness {
        background: linear-gradient(to bottom, transparent 0%, #000 100%);
        border-radius: 5px;
    }

    .hsl-gradient-crosshair {
        z-index: 1;
        position: absolute;

        width: 12px;
        height: 12px;

        border: 1px solid black;
        border-radius: 50%;

        display: flex;
        justify-content: center;
        align-items: center;

        .hsl-gradient-crosshair-inner {
            border: 2px solid white;

            width: 10px;
            height: 10px;

            border-radius: 50%;
        }
    }

</style>